import { DisplayCurrency } from '@core/interfaces/displayCurrency';
import {Environment} from '@interfaces/environments';
import packageInfo from '../../package.json';

export const environment: Environment = {
  production: true,
  showPartialPayed: false,
  hasMultipleAgencies: false,
  hasReferredUsers: false,
  showSecondsLanguages: false,
  hasTraedores: false,
  hasReservationBoat: false,
  hasBorrowers: false,
  hasSalesRestrictions: false,
  hasPriceWithTax: false,
  hasFlightNumber: false,
  hasReservationProcessing: false,
  hasReservationModification: false,
  hasBidaiondo: true,
  hasLinkeao: false,
  hasCredit: false,
  hasPeopleGoTo: false,
  hasAdg: false,
  hasAgencyReservations: false,
  hasPagoEnTransito: false,
  dateRangeForDayByDefault: true,
  showDescriptionInVoucher: false,
  isOkaturs: false,
  BoatLabel: 'Embarcaciones',
  BoatIcon: 'sailing',
  //
  apiUrl: 'https://apiexperiencias.viajessancristobal.com/v1/',
  imageUrl: 'https://cdnturismo.viajessancristobal.com/',
  securityUrl: 'https://apiseg.viajessancristobal.com/v1/',

  marketType: 'international',
  agencyName: 'Viajes San Cristobal',
  agency: 'viajessancristobal',
  imgError: '',
  ServiceBusiness: 'Experiencias',
  defaultLanguage: {
    name: 'Español',
    image: 'assets/images/flags/es.png',
    lang: 'es'
  },
  defaultCurrency: 'USD',
  defaultDisplayCurrency: DisplayCurrency.symbolNarrow,
  defaultMarket: {
    lat: 23.110774,
    lng: -82.440937
  },
  gateway: {
    visa: 'bidaiondo',
    mastercard: 'bidaiondo',
    'american-express': 'bidaiondo',
    jcb: 'bidaiondo',
    dinners: 'bidaiondo',
    iupay: 'bidaiondo',
    maestro: 'bidaiondo',
    virtual: 'bidaiondo',
    electron: 'bidaiondo',
    bizum: 'bidaiondo',
    discover: 'bidaiondo',
    adg: 'adg',
    'transferencia-QR': 'transferencia-QR',
    'in-transit': 'in-transit',
    sber: 'sber'
  },
  versions: {
    app: packageInfo.version
  },
  domain: 'viajessancristobal.com',
  gdsServices: [
    {
      icon: 'timeline',
      id: 'dashboard',
      route: 'https://portalventas.viajessancristobal.com',
      name: 'Dashboard',
      isActive: true
    },
    {
      icon: 'apartment',
      id: 'hotel',
      route: 'https://adminhoteles.viajessancristobal.com',
      name: 'Hoteles',
      isActive: true
    },
    {
      icon: 'flight',
      id: 'flight',
      name: 'Charter',
      route: 'https://adminvuelos.viajessancristobal.com/',
      isActive: false
    },
    {
      icon: 'local_play',
      id: 'experiences',
      name: 'Experiencias',
      route: 'https://adminexperiencias.viajessancristobal.com/',
      isActive: true
    },
    {
      icon: 'local_taxi',
      id: 'car',
      route: 'https://adminautos.viajessancristobal.com/',
      name: 'Autos',
      isActive: false
    },
    {
      icon: 'house',
      id: 'house',
      name: 'Casas',
      route: 'https://admincasas.viajessancristobal.com/',
      isActive: false,
    },
    {
      icon: 'airport_shuttle',
      id: 'transfer',
      name: 'Transfer',
      route: 'https://admintransfer.viajessancristobal.com/',
      isActive: false
    }
  ]
};
